import React, { useContext } from "react";
import TagIcon from "../../utils/images/tagIcon";
import RemoveIcon from "../../utils/images/RemoveIcon";
import { useState } from "react";
import { TemplateContext } from "../../layout";

const DiscountInput = ({ marginTop }) => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const [codeValue, setCodeValue] = useState("");
  const [error, setError] = useState("");
  const discountSettings = window.productData.discount_codes;

  const handleDiscountApply = () => {
    if (codeValue === discountSettings.discount_code) {
      if (discountSettings.code_has_expiration_date) {
        const [day, month, year] = discountSettings.discount_code_expiration_date.split("/");
        const expirationDate = new Date(year, month - 1, day);
        expirationDate.setHours(23, 59, 59, 999);
        const currentDate = new Date();

        if (currentDate > expirationDate) {
          setError(discountSettings.tr_expired_code_error_message);
          return;
        }
      }

      setError("");
      setTemplateContext({ ...templateContext, discountCode: codeValue });
    } else {
      setError(discountSettings.tr_discount_error_message);
    }
    setCodeValue("");
  };

  const handleRemoveDiscount = () => {
    setTemplateContext({ ...templateContext, discountCode: undefined });
    setCodeValue("");
    setError("");
  };

  return (
    <>
      {discountSettings && (
        <>
          <div className="discount__inputContainer" style={{ marginTop: marginTop ?? "" }}>
            <div className={`discount__inputContainer__input input--text`}>
              <input
                className="discount__inputContainer__styledInput"
                value={codeValue}
                onChange={(e) => setCodeValue(e.target.value)}
                placeholder="Discount code or gift card"
              />
            </div>
            <button
              type="button"
              className="discount__inputContainer__applyButton"
              onClick={() => {
                codeValue && handleDiscountApply();
              }}
            >
              <span className="discount__inputContainer__applyButton__text">Apply</span>
            </button>
          </div>
          {error && (
            <div className="discount__error" style={templateContext.discountCode ? { marginBottom: "8px" } : {}}>
              {error}
            </div>
          )}
          <div className="discount__pill__container">
            {templateContext.discountCode && (
              <div className="discount__pill">
                <TagIcon className="discount__pill__tag" />
                <span className="discount__pill__text">{templateContext.discountCode}</span>
                <div className="discount__pill__closeBtn" onClick={handleRemoveDiscount}>
                  <RemoveIcon />
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default DiscountInput;
